import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'
import ResultButton from './ResultButton'

/**
 * Copy number, SV and fusion page of a somatic analysis.
 *
 * Shown only when the list row says structural results exist (`has_structural`,
 * annotated on the analysis list query), so a row never needs its own runs
 * request and a run that was never asked for never shows a button.
 */
export const showSomaticStructuralButton = (row) => row?.tags?.includes('Somatic') && row?.has_structural === true

const GoToSomaticStructural = ({ analysisWrapperId }) => {
  const url = `/libra/somatic-structural/${analysisWrapperId}`

  const handleClick = (e) => {
    // Left click only, so middle-click still opens a new tab.
    if (e.button === 0) {
      e.preventDefault()
      window.location.href = url
    }
  }

  return (
    <Tooltip title="Copy number, structural variants and fusions" arrow>
      <ResultButton href={url} onClick={handleClick}>
        Structural
      </ResultButton>
    </Tooltip>
  )
}

GoToSomaticStructural.propTypes = {
  analysisWrapperId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
}

export default GoToSomaticStructural
